import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardBody, CardHeader } from '@heroui/react';
import { RiSettings3Line } from '@remixicon/react';

import DefaultLayout from '@/layouts/default';

export default function SettingsLandingPage() {
  const navigate = useNavigate();

  return (
    <DefaultLayout>
      <div className="space-y-6 p-6">
        <div>
          <p className="text-primary text-sm font-semibold uppercase tracking-wide">Settings</p>
          <h1 className="text-3xl font-bold">Workspace configuration</h1>
          <p className="text-default-500 mt-2 text-base">Manage routing, visibility, and administrative preferences.</p>
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          <Card>
            <CardHeader className="flex items-center gap-3">
              <RiSettings3Line className="text-primary h-5 w-5" />
              <div>
                <p className="text-lg font-semibold">Contact Sections</p>
                <p className="text-default-500 text-sm">Define inbox buckets and restrict them by role.</p>
              </div>
            </CardHeader>
            <CardBody>
              <Button color="primary" onPress={() => navigate('/settings/contact-sections')}>
                Manage sections
              </Button>
            </CardBody>
          </Card>

          <Card>
            <CardHeader className="flex items-center gap-3">
              <RiSettings3Line className="text-primary h-5 w-5" />
              <div>
                <p className="text-lg font-semibold">AI Models</p>
                <p className="text-default-500 text-sm">Order Brain fallback models, sync OpenRouter, run latency tests.</p>
              </div>
            </CardHeader>
            <CardBody>
              <Button color="primary" onPress={() => navigate('/settings/ai-models')}>
                Manage models
              </Button>
            </CardBody>
          </Card>

          <Card>
            <CardHeader className="flex items-center gap-3">
              <RiSettings3Line className="text-primary h-5 w-5" />
              <div>
                <p className="text-lg font-semibold">AI Usage & Cost</p>
                <p className="text-default-500 text-sm">Review token consumption, estimated costs, and request logs.</p>
              </div>
            </CardHeader>
            <CardBody>
              <Button color="primary" onPress={() => navigate('/reports/ai-usage')}>
                View analytics
              </Button>
            </CardBody>
          </Card>
        </div>
      </div>
    </DefaultLayout>
  );
}

